import { useLocation } from "react-router-dom";
import { useRecordNavigation } from "@jkast90/kast-common/diagnostics/react";
import { screenOf } from "../utils/screenOf";

/** Records every change of screen, deep links and back/forward included. Mount once inside the router. */
export default function NavRecorder() {
  useRecordNavigation(useLocation().pathname, screenOf);
  return null;
}
